module.exports = "<div id=\"header-container\">\n  <app-header></app-header>\n</div>\n<div class=\"container\" id=\"section-home\">\n    <div class=\"section-body\">\n        <h1>Global Business &amp; Spending Outlook 2018</h1>\n        <hr class=\"line\">\n        <h3>Middle East</h3>\n    </div>\n</div>\n<div id=\"scroll-initiator\">\n    <i class=\"fas fa-angle-double-down fa-2x\"></i>\n</div>\n\n"


//////////////////
// WEBPACK FOOTER
// /Applications/MAMP/htdocs/AMEX/sites/cfo-research/src/app/home/home.component.html
// module id = ../../../../../src/app/home/home.component.html
// module chunks = main